import { Controller } from 'stimulus'

/**
 * Manages Radio state from external trigger (StimulusJS controller)
 *
 * @class SelectRadioController
 * @extends Controllers
 */
export default class extends Controller {
  static targets = [ 'radio' ]

  /**
   * @function SelectRadioController.select
   * @description Select action
   *
   * @param {event} event
   *
   * @fires 'input'
   */
  select(event) {
    event.preventDefault()
    const targetValue = event.currentTarget.dataset.selectRadioTargetValue

    this.radioTargets.forEach(radio => {
      if (radio.value === targetValue) {
        radio.checked = true
        radio.dispatchEvent(new CustomEvent('input'))
      }
    })
  }
}
